import { useTheme } from '@mui/material'

import { IconProps } from '@f-fertighaus/applications/Next/types/icon'

export const UserHeartIcon = (props: IconProps) => {
  const theme = useTheme()
  const stroke = props.color || theme.palette.primary.main
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M6.03298 10.6099C4.46706 10.8695 3.1166 11.3735 1.92602 12.156C1.65867 12.3434 1.49965 12.6495 1.50002 12.976V15.5H7.01233'
        stroke={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <circle
        cx='8'
        cy='4'
        r='3.5'
        stroke={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14.453 9.54113C13.7241 8.82024 12.5421 8.82024 11.8132 9.54113C11.6825 9.67036 11.5841 9.81712 11.5001 9.96989C11.4161 9.81712 11.3176 9.6699 11.1865 9.54067C10.4576 8.81978 9.27557 8.81978 8.54667 9.54067C7.81778 10.2616 7.81778 11.4306 8.54667 12.1515L11.5001 15L14.453 12.1515C15.1823 11.4306 15.1823 10.262 14.453 9.54113Z'
        stroke={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
